import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import './index.css';
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<React.StrictMode data-id="element-364">
    <HelmetProvider data-id="element-365">
      <App data-id="element-366" />
    </HelmetProvider>
  </React.StrictMode>);